import { createContext } from 'react'
import { LogsContext } from './contextTypes'
export default createContext<LogsContext | null>(null)